<div class="container-fluid">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h3 class="m-0 font-weight-bold" style="color: #1A355E;">MÜŞTERİLER</h3>
        <ol class="breadcrumb ">
            <li class="breadcrumb-item active">Tanımlar</li>
            <li class="breadcrumb-item active">Müşteriler</li>
        </ol>
    </div>
    <div class="data-grid">
        <p-table #dt [value]="logoCustomers$ | async" [scrollable]="true" [rows]="100" scrollHeight="500px"
            [virtualScroll]="true" [virtualRowHeight]="10" styleClass="p-datatable-sm" [rowHover]="true"
            [globalFilterFields]="['code','definitioN_','country','city','town','addR1','telnrS1','emailaddr']"
            [responsive]="true">
            <ng-template pTemplate="caption">
                <div style="text-align: right">
                    <input style="float:right" type="text" pInputText size="50" placeholder="Ara"
                        (input)="applyFilterGlobal($event, 'contains')" style="width:auto">
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="code" [width]="'10%'">Kodu<p-sortIcon field="code"></p-sortIcon>
                    </th>
                    <th pSortableColumn="definitioN_" [width]="'50%'">Açıklama<p-sortIcon field="definitioN_">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="city" [width]="'10%'">Şehir<p-sortIcon field="city">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="telnrS1" [width]="'20%'">Tel<p-sortIcon field="telnrS1">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="emailaddr" [width]="'10%'">E-Posta<p-sortIcon field="emailaddr">
                        </p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-customers>
                <tr>
                    <td>{{customers.code}}</td>
                    <td>{{customers.definitioN_}}</td>
                    <td>{{customers.city}}</td>
                    <td>{{customers.telnrS1}}</td>
                    <td>{{customers.emailaddr}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>